import { gql } from "@apollo/client";
import { SponsoredContentsFragment } from "components/layout/sponsors/SponsorContent";

export const GET_FEATURED_EVENTS = gql`
  query getFeaturedEvents {
    featuredEvents {
        id
        name
        status
        date
        daysWindow
        eventDivisions {
          id
          division {
            id
            name
          }
        }
        series {
          id
          name
          rankingsDivisions {
            id
          }
        }
        organisation {
          id
          name
          logo
          sportType
        }
        location {
          id
          formattedAddress
        }
        ...SponsoredContents
    }
  }
  ${SponsoredContentsFragment}
`;
